import React from 'react';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Address from './Address/Address';
import { getRequest } from '../../../Helper/ApiClient';
import AddressModal from './Address/AddressModal/AddressModal';
import Link from '../../../Abstracts/Link/Link';
import LoadingSpinner from '../../../Abstracts/LoadingSpinner/LoadingSpinner';

export interface IShippingAddress {
  id: number;
  companyName: string;
  firstName: string;
  lastName: string;
  street: string;
  streetNumber: string;
  street2: string;
  zip: string;
  city: string;
  country?: ICountry;
  default: boolean;
}

export interface ICountry {
  id: number;
  name: number;
  language?: number;
  deleted?: number;
}

export default function ShippingAddress(props: {
  erpShippingAddressId?: number;
  refetchBasket: () => void;
  is_vts: boolean;
}) {
  const [showAddresses, setShowAddresses] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const shippingAddressesRequest = getRequest<IShippingAddress[]>(
    `/api/onlineshop/basket/shipping-addresses`
  );
  const shippingAddresses = shippingAddressesRequest.data;
  return (
    <>
      <Container>
        <Row>
          <Col lg={3}>
            <h2>Shipping address</h2>
          </Col>
          {shippingAddressesRequest.isSuccess && shippingAddresses ? (
            <>
              <Col lg={6}>
                {shippingAddresses.map((shippingAddress: IShippingAddress) => {
                  if (shippingAddress.id == props.erpShippingAddressId) {
                    return (
                      <Address
                        key={shippingAddress.id}
                        shippingAddress={shippingAddress}
                        is_vts={props.is_vts}
                      />
                    );
                  }
                })}
              </Col>
              <Col lg={3} className={'text-end'}>
                <Link
                  underline
                  onClick={() => {
                    setShowAddresses(!showAddresses);
                  }}
                >
                  Change shipping address
                </Link>
              </Col>
            </>
          ) : (
            <>
              <Col lg={9}>
                <LoadingSpinner />
              </Col>
            </>
          )}
        </Row>
      </Container>
      {showAddresses && (
        <>
          <Container className={'pt-4'}>
            <AddressModal
              show={showNew}
              onHide={() => setShowNew(false)}
              refetch={shippingAddressesRequest.refetch}
              is_vts={props.is_vts}
            />
            <Row>
              <Col lg={3}>Select a shipping address</Col>
              <Col lg={9}>
                <div className={'pb-4'}>
                  Is the address you´d like to use displayed below?
                  <br />
                  If so, click the corresponding “Deliver to this address”
                  button. Or you can
                  <Link underline onClick={() => setShowNew(true)}>
                    {' '}
                    enter a new shipping address
                  </Link>
                  .
                </div>
                <Row>
                  {shippingAddressesRequest.isSuccess &&
                    shippingAddresses &&
                    shippingAddresses.map(
                      (shippingAddress: IShippingAddress) => {
                        return (
                          <Col key={shippingAddress.id} lg={4} xs={6}>
                            <Address
                              shippingAddress={shippingAddress}
                              editable={true}
                              refetchAddresses={
                                shippingAddressesRequest.refetch
                              }
                              refetchBasket={props?.refetchBasket}
                              selected={
                                shippingAddress.id == props.erpShippingAddressId
                              }
                              is_vts={props.is_vts}
                            />
                          </Col>
                        );
                      }
                    )}
                </Row>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </>
  );
}
